export default __webpack_public_path__ + "static/media/edit.9de65eb5.svg";